import { INFO_THEME_COUNTDOWN } from '../components/infoblock'
import React from 'react'

export const CONTENT_INFOBLOCK_COUNTDOWN_BOX = {
  content: (
    <p>
      Die für den 20. März 2026 geplante SpeaKonf findet leider nicht statt.
      Wir informieren euch hier, sobald ein neuer Termin feststeht.
    </p>
  ),
  action: null,
  title: null,
  theme: INFO_THEME_COUNTDOWN,
  disableMargin: true,
}
